import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface GridCSSStyle extends UIComponentCSSStyle
{
    getListRowCSSStyle(): object;
}

export class GridCSSStyleImpl extends UIComponentCSSStyleImpl implements GridCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            listStyleType: "none",
            width: "100%",
            height: "100%",
            display: "flex",
            textAlign: "center",
            justifyContent: 'center', 
            flexFlow: "row wrap"
        };
    }
    
    getListRowCSSStyle(): object 
    {
        return {
            width: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            marginTop: "20px",
            textAlign: "center",
            justifyContent: 'flex-center', 
            borderRadius: '8px'
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/grid/gridcss.tsx